import {z} from 'zod';

const VIN_REGEX = /^[A-HJ-NPR-Z0-9]{17}$/;

export const scannedVINSchema = z.object({
  vin: z.string().length(17).regex(VIN_REGEX).nullish(),
});

export type ScannedVIN = z.infer<typeof scannedVINSchema>;
